import { Link } from 'react-router-dom';
import { Github, Twitter, Mail } from 'lucide-react';
import config from '../../data/site_config.json';
import { parseMarkdownItalics } from '../SafecareBrand';
import './Footer.css';

const hasRealLink = (url) => url && url.trim() !== '' && url !== '#';

export default function Footer() {
    const socials = [
        { key: 'twitter', href: config.socials?.twitter, icon: Twitter, label: 'Twitter' },
        { key: 'github', href: config.socials?.github, icon: Github, label: 'GitHub' },
        { key: 'contact', href: config.socials?.contact, icon: Mail, label: 'Contact' },
    ].filter(({ href }) => hasRealLink(href));
    const showConnect = socials.length > 0;

    return (
        <footer className="footer">
            <div className="container footer-content">
                <div className="footer-section">
                    <h3>{parseMarkdownItalics("SAFEC+")}</h3>
                    <p className="footer-tagline">Healthcare is essential infrastructure.</p>
                </div>

                <div className="footer-section">
                    <h4>Links</h4>
                    <div className="footer-links">
                        {config.navigation.map(item => (
                            <Link key={item.path} to={item.path}>{item.label}</Link>
                        ))}
                    </div>
                </div>

                {showConnect && (
                    <div className="footer-section">
                        <h4>Connect</h4>
                        <div className="footer-socials">
                            {socials.map(({ href, icon: Icon, label }) => (
                                <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label}>
                                    <Icon size={20} />
                                </a>
                            ))}
                        </div>
                    </div>
                )}
            </div>
            <div className="footer-bottom">
                <p>
                    &copy; 2026 {parseMarkdownItalics("SAFEC+")} Initiative
                    <br />
                    The Secure American Fair Essential Care Plus ({parseMarkdownItalics("SAFECare+")}) Act Independent Legislative Proposal for National Health Infrastructure & Debt Redemption.
                </p>
            </div>
        </footer>
    );
}
